import React from 'react';
import SearchModal from './SearchModal';
import CategorySearchModal from './CategorySearchModal';
import config from '../config/config';

const ICON_URLS = {
  menu: `${config.icons.baseUrl}${config.icons.menu}`,
  close: `${config.icons.baseUrl}${config.icons.close}`,
  arrowTopRight: `${config.icons.baseUrl}${config.icons.arrowTopRight}`,
  keyboardBackspace: `${config.icons.baseUrl}${config.icons.keyboardBackspace}`,
};

/**
 * 検索コンポーネント
 */
const Search = ({
  map,
  center,
  isSearchModalOpen,
  onOpenSearchModal,
  onCloseSearchModal,
  isCategorySearchModalOpen,
  onOpenCategorySearchModal,
  onCloseCategorySearchModal,
  handleSearch,
  handleSuggestionSelect,
  handleCategorySelection,
  onMenuOpen,
  setIsSearchResultOpen,
  searchQuery,
  setSearchQuery,
  selectedCategory,
  handleCloseSearchResult,
  naviToggle
}) => {

  // 「search-box-container」「category-tags-container」の2つの区分
  return (
    <>
      <div className="search-container">
        <div className="search-wrapper">
          {/* 検索ボックスのコンテナ */}
          <div className="search-box-container">
            <div className="search-box">
              {/* メニューボタン */}
              <button
                className="menu-toggle"
                id="open-menu"
                onClick={onMenuOpen}
              >
                <i className="svg-icon-blue" style={{ backgroundImage: `url('${ICON_URLS.menu}')` }}></i>
              </button>

              {/* 通常の検索モード */}
              <input
                type="text"
                className="search-input"
                placeholder="場所を検索"
                value={searchQuery}
                readOnly
                // マウス押下 / タッチ開始でモーダルを開く（ドラッグ開始でも反応）
                onMouseDown={() => {
                  onOpenSearchModal();
                  setIsSearchResultOpen(false);
                }}
                onTouchStart={() => {
                  onOpenSearchModal();
                  setIsSearchResultOpen(false);
                }}
              />

              {searchQuery && (
                <button
                  className="search-input-clear-btn"
                  // 検索関連の閉じるボタンは共通で、ワード・カテゴリ・結果・マップのピンをクリアする
                  onClick={handleCloseSearchResult}
                  aria-label="検索ワードをクリア"
                >
                  <i
                    className="svg-icon-black"
                    style={{
                      backgroundImage: `url('${ICON_URLS.close}')`
                    }}>
                  </i>
                </button>
              )}

              <button
                className="search-type-toggle"
                title="ルート検索に切り替え"
                onClick={() => naviToggle()}
              >
                <i
                  className="svg-icon-blue"
                  style={{ backgroundImage: `url('${ICON_URLS.arrowTopRight}')` }}
                ></i>
              </button>

            </div>
          </div>

          {/* カテゴリタグのコンテナ */}
          <div className="category-tags-container">
            <div className="category-tags">

              <button
                className={`category-tag${selectedCategory === 'グルメ' ? ' selected' : ''}`}
                data-type="グルメ"
                onClick={() => handleCategorySelection('グルメ')}
              >
                グルメ
              </button>

              <button
                className={`category-tag${selectedCategory === 'コンビニ' ? ' selected' : ''}`}
                data-category="M02005"
                data-category-name="コンビニ"
                onClick={() => handleCategorySelection('コンビニ')}
              >
                コンビニ
              </button>

              <button
                className={`category-tag${selectedCategory === '公園' ? ' selected' : ''}`}
                data-category="M04010"
                data-category-name="公園"
                onClick={() => handleCategorySelection('公園')}
              >
                公園
              </button>

              <button
                className="category-tag more-btn"
                id="openCategorySearch"
                onClick={() => onOpenCategorySearchModal()}>
                <span>もっと見る</span>
              </button>
            </div>

          </div>
        </div>
      </div >

      {/* 検索モーダル表示 */}
      {
        isSearchModalOpen && (
          <SearchModal
            map={map}
            // 検索ボックスの現在の値を保持
            searchQuery={searchQuery}
            // searchQueryを更新する関数
            setSearchQuery={setSearchQuery}
            // 実行時
            onSubmit={handleSearch}
            // サジェスト項目選択時
            onSuggestionSelect={handleSuggestionSelect}
            // モーダルを閉じる
            onCloseSearchModal={onCloseSearchModal}
            // 検索関連の閉じるボタンは共通で、ワード・カテゴリ・結果・マップのピンをクリアする
            handleCloseSearchResult={handleCloseSearchResult}
            center={center} />
        )
      }

      {/* カテゴリ検索モーダル表示 */}
      {
        isCategorySearchModalOpen && (
          <CategorySearchModal
            // モーダルを閉じる
            onCloseCategorySearchModal={() => onCloseCategorySearchModal()}
            // カテゴリが選択された時に呼び出される
            handleCategorySelection={handleCategorySelection}
          />
        )
      }
    </>
  );
};
export default Search;